import { CSSProperties, useEffect, useState } from "react";
import { SkaalDigitalPourBlockSettings } from "../SkaalDigitalPourProps.interface";

const getSkallCSS = (settings: SkaalDigitalPourBlockSettings) => {
    const styles = {};

    if (settings?.primaryColor) {
        styles["--primary-color"] = settings?.primaryColor;
    }
    if (settings?.secondaryColor) {
        styles["--secondary-color"] = settings?.secondaryColor;
    }

    return styles;
};

export default (settings: SkaalDigitalPourBlockSettings): any => {
    const [result, setResult] = useState<CSSProperties>(getSkallCSS(settings));

    useEffect(() => {
        setResult(getSkallCSS(settings));
    }, [settings]);

    return result;
};